import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import { AuthToken } from '../../Models/AuthToken.model';

@Injectable()
export class ApiService {
    TokenData: AuthToken;
    constructor(private _http: Http) {
    }
    get(url: string): Observable<any> {
        //this.TokenData = JSON.parse(sessionStorage.getItem('Token'));
        const headers = new Headers({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            //'Authorization': this.TokenData.token_type + ' ' + this.TokenData.access_token,
        });
        const options = new RequestOptions({ headers: headers });
        return this._http.get(url, options).map((response: Response) => <any>response.json())
            .catch(this.handleError);
    }
    post(url: string, model: any): Observable<any> {
        const body = JSON.stringify(model);
        //this.TokenData = JSON.parse(sessionStorage.getItem('Token'));
        console.log(body);
        const headers = new Headers({
            'Content-Type': 'application/json',
            //'Authorization': this.TokenData.token_type + ' ' + this.TokenData.access_token,
            'Accept': 'application/json',
        });
        const options = new RequestOptions({ headers: headers });
        return this._http.post(url, body, options)
            .map((response: Response) => <any>response.json())
            .catch(this.handleError);
    }

    put(url: string, id: number, model: any): Observable<any> {
        const body = JSON.stringify(model);
        const headers = new Headers({
            'Content-Type': 'application/json',
            'x-access-token': localStorage.getItem('Token'),
        });
        const options = new RequestOptions({
            headers: headers
        });
        return this._http.put(url + id, body, options).map((response: Response) => <any>response.json()).catch(this.handleError);
    }
    delete(url: string, id: number): Observable<any> {
        const headers = new Headers({
            'Content-Type': 'application/json'
        });
        const options = new RequestOptions({
            headers: headers
        });
        return this._http.delete(url + id, options).map((response: Response) => <any>response.json()).catch(this.handleError);
    }

    private handleError(error: Response) {
        console.log(error);
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }
    // tslint:disable-next-line:eofline
}

